import { pageFactory } from "./factory";
import { vnAppZone } from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone";
import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";

import {
    XMLHttpRequestHandler,
    XMLHttpRequestHandler_requestType
} from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import { pagination_template } from "../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import { validationsList_template } from "../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/validationsList_template";
import {vn_app_zone_notification} from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";
import {transactionsPaymentList_template} from "../components/templates/transactionsPaymentList_template";
import {transactionsPaymentSummaryPrintable_template} from "../components/templates/transactionsPaymentSummaryPrintable_template";

declare var ko: any;
declare var page: any;

export class transactions_payment_summary_printable extends vnModule_knockoutJS{

    protected XHRHdl: XMLHttpRequestHandler;
    protected elementsList: transactionsPaymentSummaryPrintable_template;

    protected getModuleName(){
        return "transactions_payment_summary_printable";
    }

    buildContent() : Array<Element>{

        this.elementsList = new transactionsPaymentSummaryPrintable_template("summary", this.viewModel, this);

        return [this.elementsList.build()];
    }

    public fillPage() : void{

        this.getSummary();
    }

    protected getSummary(){

        // LOADING : starts
        this.loadingIn(this.elementsList.builtTemplate.children.namedItem("list-results"));

        if( this.XHRHdl ){
            this.XHRHdl.cancelAndReset();
        }

        let id: number;
        let action: string;

        if( (id = this.getVnAppZone().app.params.paymentId) && !isNaN(id)) {
            this.viewModel["summary"].idPayment(id);
        }

        let usrReq_url: string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + '/transactions/payments/summary/printable/';
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push( ["data", ko.toJSON(this.viewModel["summary"])] );
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url,usrReq_params, this);

        let localCheck = this.XHRHdl.requestId;
        let _myThis = this;
        setTimeout(function(){

            if( localCheck == _myThis.XHRHdl.requestId ){
                _myThis.XHRHdl.onReadyStateFunction = _myThis.onFilterRequestReturn;
                _myThis.XHRHdl.execute();
            }
        }, 400);
    }

    protected onFilterRequestReturn(req, obj){

        return function(){

            if (req.request.readyState == 4) {

                let responseParsed = JSON.parse(req.request.response);
                let data = responseParsed.data;

                if(  req.request.status == 200  ){
                    obj.elementsList.validationsList.clearMessages();

                    obj.updateList(data);
                }
                else{
                    obj.onUpdateError(req.request.status, responseParsed);
                }

                // LOADING : ends
                obj.loadingOut(obj.elementsList.builtTemplate.children.namedItem("list-results"));
            }
        }
    }

    //
    // update the module list using the objects list
    protected updateList(responseParsed: any){

        // set users list
        let users = [];
        for (var key in responseParsed.users) {
            let item = responseParsed.users[key];
            var total = (item.total < 0) ? '$0.00 ($' + item.total.toFixed(2) + ')' : '$' + item.total.toFixed(2);
            var payment_date = item.payment_date.substring(0,10);

            for (let transaction of item.transactions) {
                transaction.item.title = transaction.item.title.substring(0, 15) + '...';

                if (transaction.idActionType == 2) {
                    transaction.entry_type = "Reversal";
                }

                if (transaction.idActionType == 1) {
                    transaction.entry_type = "Payment - " + transaction.entryType.name.substring(transaction.entryType.name.indexOf("for ") + 4);
                }

                transaction.amount = (transaction.idType == 1) ? '-$' + Number(transaction.amount).toFixed(2) : '$' + Number(transaction.amount).toFixed(2);
                transaction.dateCreation = transaction.dateCreation.substring(0, 10);

            }

            users.push( {
                total:  total
                ,user_id: item.user_id
                ,user_fullName: item.user_fullName
                ,payment_date: payment_date
                ,currency: item.currency
                ,transactions: item.transactions
            } )
        }

        this.elementsList.setUsers(users);
    }


    protected onUpdateError(requestStatus: any, responseParsed) : void{
        let msg = "error: while obtaining the data - (" + requestStatus +")";
        this.elementsList.validationsList.setSingleMessage({field: "error", "label": requestStatus, message: msg});
        window.scrollTo(0, 0);
    }



}



// WEBPACK FOOTER //
// ./js/modules/transactions_payment_summary_printable.ts